import { createStructuredSelector } from "reselect";
import { allowedWorkareaSelector } from "../auth/selectors";

export const workareaSelector = state => state.workarea;
export const organizationSelector = state => state.organization;

export default createStructuredSelector({
  workarea: workareaSelector,
  organization: organizationSelector,
  allowedWorkareas: allowedWorkareaSelector
});
